import React from 'react'
import { Outlet, Link } from "react-router-dom";
import reservacion from '../assets/images/cta/reservacion.svg'
import formulario from '../assets/images/formulario-de-contacto.svg'
import mapa from '../assets/images/pregutas.png'
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer'
import FormCondicionesMedicas from '../components/frames/FormCondicinesMedicas';

export default function CondicionesMedicas() {
    const { t } = useTranslation('contacto');
    
  return (
    <>
     <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                    <h3>Condiciones Médicas</h3>
                    <p>Completa este formulario una vez que hayas realizado tu reservación</p>
                </div>                
            </div>
        </div>
    </section>

    <section style={{background:'#E8E8E8',padding: '6rem 0rem'}}>
        <div className='container'>
            <FormCondicionesMedicas />
        </div>
    </section>

    <section className="callToAction">
        <div className='container'>
            <div>
                <h3> </h3>
            </div>
            <div className='callToAction_row'>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={formulario} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title1')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title1')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/tarifas">{t('cta_btn1')}</Link>     
                        </div>
                    </div>
                </div>
                <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={mapa} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title2')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title2')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                            <Link to="/preguntas-frecuentes">{t('cta_btn2')}</Link>     
                        </div>
                    </div>
                </div>
                {/*<div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={whatsapp} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>Envianos un WhatsApp</h4>
                            </div>
                            <div>
                                <p>Comunícate con nosotros al instante. Ya sea que tengas preguntas sobre nuestro servicio, o sobre tu reservación nuestro equipo está listo para ayudarte.</p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                        <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer">Enviar WhatsApp </a>                    
                        </div>
                    </div>
                </div>*/}
                    <div className='callToAction_container'>
                <div className='callToAction_icon'>
                    <img src={reservacion} alt="bookingIcon" className='bookingIcon' />
                </div>
                <div className='callToAction_content'>
                    <div className='callToAction_box'>
                        <div>
                            <h4>{t('cta1_title3')}</h4>
                        </div>
                        <div>
                            <p>{t('cta_title3')} </p>
                        </div>
                    </div>
                    <div className='callToAction_box'>
                        <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn3')} </a>                        
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>

    <Outlet />

    <Footer />

    </>
  )
}
